import { LinkIcon } from "@/shared/ui";
import { sidebarMenuVariants } from "../variants";

const { linkIcon } = sidebarMenuVariants();

interface LinkItemProps {
  link: string;
  label: string;
}

export const LinkItem = ({ link, label, ...props }: LinkItemProps) => {
  return (
    <a href={link} rel="noreferrer noopener" target="_blank" {...props}>
      {label}
      <LinkIcon className={linkIcon()} />
    </a>
  );
};
